import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { Observable } from "rxjs/Observable";
import { Util } from "src/app/shared/helpers/util";
import { AES_INFO } from "src/app/shared/constants/common.const";
import { ModalService } from "src/app/core/services/modal.service";
import { AuthService } from "src/app/core/services/auth.service";
import * as $ from "jquery";
import { TranslateService } from "@ngx-translate/core";
import { LogService } from "src/app/core/services/log.service";
import sha256 from 'crypto-js/sha256';

declare let CryptoJS: any;

@Injectable({
  providedIn: "root",
})
export class HttpClientService {
  public serverUrl: string;
  private util = new Util();
  private viewText: any;
  isError = false;

  constructor(
    private httpClient: HttpClient,
    private authService: AuthService,
    private modalService: ModalService,
    private translate: TranslateService,
    private logger: LogService
  ) {
    this.translate = translate;
    this.serverUrl = environment.OMMServer.server;
    if (environment.OMMServer.port && environment.OMMServer.port !== "") {
      this.serverUrl += ":" + environment.OMMServer.port;
    }
    if (environment.OMMServer.context && environment.OMMServer.context !== "") {
      this.serverUrl += "/" + environment.OMMServer.context + "/";
    } else {
      this.serverUrl += "/";
    }
    this.viewText = this.translate.instant("COMMON");
  }

  public getServerURI() {
    return this.serverUrl;
  }

  private encrypt(plaintext: string, password: string) {
    const iv = CryptoJS.lib.WordArray.random(128 / 8);
    const key = CryptoJS.enc.Hex.parse(CryptoJS.SHA1(password).toString().substring(0, 32));
    // const key = CryptoJS.enc.Hex.parse(sha256(password).toString().substring(0, 64));
    const ct = CryptoJS.AES.encrypt(plaintext, key, { iv });
    return iv.concat(ct.ciphertext).toString();
  }

  public httpPost(api: string, TrClass: any): Observable<any> {
    $("div.loading").removeClass("none");
    this.logger.log("Request Code : " + api);
    this.logger.log("Request Object : ");
    this.logger.log(JSON.stringify(TrClass));
    const TrResponse = this.getTrResponse(api, TrClass);
    return TrResponse;
  }

  private getTrResponse(api: string, TrClass: any) {
    const uri = this.serverUrl + api;
    const aesInfo: any = this.util.getSecureStorage(AES_INFO.STORE) || {};

    const httpOptionsObj = {
      "Content-Type": "application/json",
    };

    if (environment.encryptionUse) {
      aesInfo.timestamp = new Date().getTime();
      this.util.setSecureStorage(AES_INFO.STORE, aesInfo);
      if (!(api === "RSA" || api === "AES" || api === "PME0621" || api === "PME0611" || api === "PME0113" || api === "PME0613" || api === "PME0612")) {
        if (
          !aesInfo.aesKey ||
          !aesInfo.timestamp ||
          new Date().getTime() - aesInfo.timestamp > environment.autoLogoutTime
        ) {
          this.modalService.alert({
            content: this.viewText.LABEL.AUTO_LOGOUT1 + "\n" + this.viewText.LABEL.AUTO_LOGOUT2 + "\n" + this.viewText.LABEL.AUTO_LOGOUT3,
            callback: () => {
              this.httpPost("signout", {});
              this.authService.logout();
            },
          });
        } else {
          TrClass.body = this.encrypt(
            JSON.stringify(TrClass.body),
            aesInfo.aesKey
          );
        }
      }
    }

    httpOptionsObj["Content-MD5"] = `${environment.encryptionUse}`;
    if (aesInfo.authToken) {
      // tslint:disable-next-line: no-string-literal
      if (!(api === "RSA" || api === "PME0621" || api === "PME0611" || api === "PME0113" || api === "PME0613" || api === "PME0612")) {
        httpOptionsObj[ "AUTH_TOKEN" ] = aesInfo.authToken;
      }
    }

    return this.httpClient.post(uri, JSON.stringify(TrClass), {
      headers: new HttpHeaders(httpOptionsObj),
    });
  }

  public httpGet(api: string, TrClass: any): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };
    const uri = this.serverUrl + api + "?message=" + JSON.stringify(TrClass);

    return this.httpClient.get(uri, httpOptions);
  }

  public checkResponse(response: any): boolean {
    if (response.header.result) {
      return true;
    } else {
      this.logger.log("error");
      this.logger.log(response);

      if (!this.isError) {
        this.isError = true;
        if (
          response.header.resultCode === "CBK_401" ||
          response.header.resultCode === "CBK_SES_001"
        ) {
          this.modalService.alert({
            content: response.header.resultMessage,
            callback: () => {
              this.isError = false;
              this.httpPost("signout", {});
              this.authService.logout();
            },
          });
        } else if (response.header.resultCode === "CBK_ERR0000") {
          this.modalService.alert({
            content: response.header.resultMessage,
            callback: () => {
              this.isError = false;
            },
          });
        } else if (response.header.resultCode === "999999") {
          this.modalService.alert({
            content: "Connection lost.",
            callback: () => {
              this.isError = false;
            },
          });
        } else {
          if ( response.header.resultCode === "110536" ) {
            return;
          } else {
            this.modalService.alert({
              content: response.header.resultMessage,
              callback: () => {
                this.isError = false;
              },
            });
          }
        }
      }
      return false;
    }
  }

  public checkResponseResult(response: any): null | { resultCode: string; resultMessage: string } {
    if (response.header.result) {
      return null;
    } else {
      const errorData = {
        resultCode: "",
        resultMessage: "",
      };
      if (
        response.header.resultCode === "CBK_401" ||
        response.header.resultCode === "CBK_SES_001"
      ) {
        errorData.resultCode = response.header.resultCode;
        errorData.resultMessage = (environment.production && "[" + response.header.resultCode + "] ") + response.header.resultMessage;
      } else if (response.header.resultCode === "CBK_ERR0000") {
        errorData.resultCode = response.header.resultCode;
        errorData.resultMessage = (environment.production && "[" + response.header.resultCode + "] ") + response.header.resultMessage;
      } else if (response.header.resultCode === "999999") {
        errorData.resultCode = response.header.resultCode;
        errorData.resultMessage = (environment.production && "[" + response.header.resultCode + "] ") + "Connection lost.";
      } else {
        errorData.resultCode = response.header.resultCode;
        errorData.resultMessage = (environment.production && "[" + response.header.resultCode + "] ") + response.header.resultMessage;
      }
      return errorData;
    }
  }
}
